import { ReactComponent as Responsive } from "../assets/icons/responsive.svg";
import { ReactComponent as Frontend } from "../assets/icons/frontend.svg";
import { ReactComponent as Speed } from "../assets/icons/speed.svg";
import { ReactComponent as Dynamic } from "../assets/icons/dynamic.svg";
import { ReactComponent as Team } from "../assets/icons/team.svg";
import { ReactComponent as Detail } from "../assets/icons/detail.svg";

export const aboutData = [
  {
    svg: <Frontend />,
    title: "FRONT-END",
    description: "I bring ideas to life with user-friendly UI."
  },
  {
    svg: <Responsive />,
    title: "RESPONSIVE",
    description: "My layouts will be compatible with any device. Big or small. "
  },
  {
    svg: <Speed />,
    title: "SPEED",
    description: "I prioritize swift interaction."
  },
  {
    svg: <Dynamic />,
    title: "DYNAMIC",
    description: "I build websites that don't have to be static."
  },
  {
    svg: <Team />,
    title: "TEAM PLAYER",
    description: "I'm a strong team player who fosters collaboration."
  },
  {
    svg: <Detail />,
    title: "DETAIL ORIENTED",
    description: "I pay great attention to detail."
  },
];